/**
 * Generic CSV generator
 */
export function generateGenericCSV(data: Record<string, any>[]): string {
  if (!data || data.length === 0) return "";

  // Collect all unique headers
  const allHeaders = Array.from(
    new Set(data.flatMap((row) => Object.keys(row)))
  );

  // Keep only headers that have at least one non-empty value
  const headers = allHeaders.filter((header) =>
    data.some((row) => {
      const value = row[header];
      return value !== null && value !== undefined && value !== "" && value !== "—";
    })
  );

  const csvRows: string[] = [];

  // Header row
  csvRows.push(headers.join(","));

  // Data rows
  for (const row of data) {
    const values = headers.map((header) => {
      let value = row[header];

      // Handle null/undefined
      if (value === null || value === undefined) return "";

      // Handle objects (convert to JSON string)
      if (typeof value === "object") {
        return `"${JSON.stringify(value).replace(/"/g, '""')}"`;
      }

      // Escape quotes
      return `"${(value).toLocaleString().replace(/"/g, '""')}"`;
    });

    csvRows.push(values.join(","));
  }

  // Add BOM for Excel encoding fix
  return "\uFEFF" + csvRows.join("\n");
}
